var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#306af5;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0c0c0c",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-632.5 -133.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 632.5, 133.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(7.5 3.5)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(647 144)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperActiveIcon);
export default __webpack_public_path__ + "static/media/stepper-active-icon.022a90dbc90788e8e359cfcd9dd70b6d.svg";
export { ForwardRef as ReactComponent };